import React, { useState, useEffect } from 'react';
import { NavLink } from 'react-router-dom';
import { fetchActiveJobCount } from '../services/jobService';
import './Header.css';

const Header = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [activeJobCount, setActiveJobCount] = useState(0);

  useEffect(() => {
    const loadCount = async () => {
      try {
        const count = await fetchActiveJobCount();
        setActiveJobCount(count);
      } catch (err) {
        console.error('Failed to fetch active job count:', err);
      }
    };
    loadCount();
  }, []);

  return (
    <header className="header">
  <div className="top-row">
    <button className="hamburger" onClick={() => setMenuOpen(!menuOpen)}>☰</button>

    <div className="brand">
      <div className="logo">Currentjobs.co.ke</div>
      <p className="tagline">Your Gateway to Career Growth.</p>
    </div>

    <div className="job-count">
      🚀 {activeJobCount} Active Job{activeJobCount !== 1 ? 's' : ''}
    </div>
  </div>

  <nav className={`mobile-nav ${menuOpen ? 'open' : ''}`}>
  <NavLink to="/" onClick={() => setMenuOpen(false)}>Home</NavLink>
  <NavLink to="/about" onClick={() => setMenuOpen(false)}>About</NavLink>
  <NavLink to="/services" onClick={() => setMenuOpen(false)}>Services</NavLink>
  <NavLink to="/faq" onClick={() => setMenuOpen(false)}>FAQ</NavLink>
  <NavLink to="/contact" onClick={() => setMenuOpen(false)}>Contact Us</NavLink>
</nav>
</header>
  );
};

export default Header;
